import { useSelector } from 'react-redux'
import { StateExtended } from '../../interfaces/StateExtended'

export function useCityAlertSelector() {
    const data = useSelector((state: StateExtended) => state.cityAlert.data.cityDetails)
    return data
}